import { Pipe, PipeTransform } from '@angular/core';
import { TotvsTranslateProvider } from '../../providers/totvs-translate-provider';

/**
 * Generated class for the TotvsTranslatePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */

@Pipe({
  name: 'tTranslate',
  
})
export class TotvsTranslatePipe implements PipeTransform {

  constructor(
    private _translateProvider: TotvsTranslateProvider) {
}

  transform(value: string, component:string, interpolateParams?: Object) {
    return this._translateProvider.get(value, component, interpolateParams);
  }
}
